import { SelectDesignTokens } from '@primeng/themes/types/select';

interface ICustomSelectButtonDesignTokens extends SelectDesignTokens {
  root: SelectDesignTokens['root'] & {
    fontSize: string;
    selectOpenColor: string;
    selectOpenBorderColor: string;
    selectOpenBackground: string;
    hoverBackground: string;
  };
}

export const baseSelectToken: ICustomSelectButtonDesignTokens = {
  root: {
    background: 'transparent',
    color: '{primary.500}',
    borderColor: '{primary.100}',
    disabledBackground: '{gray.50}',
    disabledColor: '{gray.500}',
    hoverBorderColor: '{primary.100}',
    hoverBackground: '{neutral.500}',

    selectOpenColor: '{white}',
    selectOpenBackground: '{primary.500}',
    selectOpenBorderColor: '{primary.500}',
    fontSize: '12px',

    shadow: 'none',
    borderRadius: '4px',
    paddingX: '8px',
    paddingY: '4px',
    focusRing: {
      color: '{primary.700}',
      shadow: 'none',
      offset: '1px',
    },
  },
  dropdown: {
    width: 'auto',
    color: 'inherit',
  },
  overlay: {
    borderRadius: '8px',
    shadow: '0 0.25rem 1.5rem 0 #00000033',
    borderColor: '{white}',
    background: '{white}',
    color: '{gray.950}',
  },
  list: {
    padding: '4px',
    gap: '4px',
  },
  option: {
    focusBackground: '{neutral.500}',
    selectedBackground: '{neutral.500}',
    selectedFocusBackground: '{neutral.500}',
    color: '{gray.950}',
    focusColor: '{gray.950}',
    selectedColor: '{gray.950}',
    selectedFocusColor: '{gray.950}',
    padding: '4px 12px',
    borderRadius: '4px',
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
      .p-select {
        font-size: ${dt('select.fontSize')};
        color: ${dt('select.color')};
      }

      .p-select:hover {
        background-color: ${dt('select.hoverBackground')};
        border-color: ${dt('select.hoverBorderColor')} !important;
      }

      .p-select.p-select-open {
        color: ${dt('select.selectOpenColor')};
        background-color: ${dt('select.selectOpenBackground')};
        border-color: ${dt('select.selectOpenBorderColor')} !important;
      }
      .p-select.p-select-open .p-select-label {
        color: ${dt('select.selectOpenColor')};
      }
      .p-select-dropdown {
        padding-left: 0;
        padding-right: ${dt('select.paddingY')};
        color: inherit !important;
      }
    `,
};
